import { createAsyncAction, createDispatchAsyncAction } from 'wiloke-react-core/utils';

export const importFileCSV = createAsyncAction([
  '@Builder/importFileCSV/request',
  '@Builder/importFileCSV/success',
  '@Builder/importFileCSV/failure',
])<{ file: File; email: string; onFulfilled?: () => void }, { message: string }, { message: string }>();

export const useImportFileCSV = createDispatchAsyncAction(importFileCSV);
